<div class="sizzleOverlayWrapper" [ngClass]="{open: pageDataService.isOverlayOpen}">
    <div class="close" (click)="onClose()">
        <img src="assets/img/icons/close-white.png" alt="">
    </div>

    <div class="videoHolder">
        <video [src]="pageDataService.overlayVideo" *ngIf="pageDataService.overlayVideo != ''" [muted]="false" playsInline="true" [autoplay]="true" [loop]="false" [controls]="true" ></video>
    </div>

</div>